// Generated by CoffeeScript 2.7.0
var Admin__Settings__PushTemplateController;

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import SettingsNavigator from 'trunks/vue/admin/compositions/settings_sidebar/settings_navigator.js';

import SettingsPushTemplate from 'trunks/vue/admin/components/settings/settings_container/settings_push_template.js';

export default Admin__Settings__PushTemplateController = (function() {
  class Admin__Settings__PushTemplateController extends Skylark.App.BaseController {
    show() {
      this._generateSettingsSidebarView('settings__basic');
      return new SettingsPushTemplate({
        el: DomMaster.find("#js-settings-push_template").node,
        propsData: {
          activeTab: 'push_template'
        }
      });
    }

  };

  Admin__Settings__PushTemplateController.include(GenerateMorePopover);

  Admin__Settings__PushTemplateController.include(SettingsNavigator);

  return Admin__Settings__PushTemplateController;

}).call(this);
